import React from 'react';
import PropTypes from 'prop-types';
import { StyledSlide } from '../css';

const Slide = ({ item }) => {
  const {
    heading, thumbnailImage, heroImage, url,
  } = item;

  // Use thumbnailImage if available, fallback to heroImage
  const hasThumbnail = thumbnailImage && thumbnailImage.jss && thumbnailImage.jss.value && thumbnailImage.jss.value.src;
  const image = hasThumbnail ? thumbnailImage : heroImage;
  const imgSrc = (image && image.jss && image.jss.value && image.jss.value.src)
    ? image.jss.value.src
    : null;
  const altText = (image && image.jss && image.jss.value && image.jss.value.alt)
    ? image.jss.value.alt
    : 'Image';
  const bgImg = imgSrc ? `url('${imgSrc}')` : 'none';

  return (
    <StyledSlide className="slide">
      <a href={url} aria-label={heading && heading.value ? heading.value : altText}>

        <div
          className="slide-image"
          role="img"
          aria-label={altText}
          title={altText}
          style={{ backgroundImage: bgImg }}
        />

        {(heading && heading.value) && <div className="slide-title">{heading.value}</div>}

      </a>
    </StyledSlide>
  );
};

Slide.propTypes = {
  item: PropTypes.object,
};

export default Slide;
